import "./node_modules/bootstrap/scss/bootstrap.scss";
import "./src/css/index.css"
import "./src/styles/global.scss"
import './src/styles/component/Nav.style.scss'
